<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Profile</h1>
        </div>
        <div class="content-section">
            <div class="order-view  max-WT-700 mrgn-0-auto setting-page">
                <div class="mb40">
                    <div class="admin-profile">
                        <h4 class="mb20 text-center">View Profile</h4>
                    </div>
                    <div class="add-store-block input-style view-label-align">
                        <div class="form-group row align-items-baseline">
                            <div class="col-md-12" style="text-align: center">
                                <img src="{{profileData?.profilePic || 'assets/img/profile-img.jpg' }}"
                                    style="height: 100px;width: 100px; border-radius: 50%; border: 1px solid black!important;" alt="profile image">
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline">
                            <label class="col-md-4 textalignright ">Name <span>:</span></label>
                            <div class="col-md-8 textaligncenter">
                                <div class="form-group">
                                    <p style="padding: 0px 5px!important;" >
                                        {{profileData?.name || '--'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline">
                            <label class="col-md-4 textalignright">Email <span>:</span></label>
                            <div class="col-md-8 textaligncenter">
                                <div class="form-group ">
                                    <p class="content-view" >
                                        {{profileData?.email || '--'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline">
                            <label class="col-md-4 textalignright">Mobile Number <span>:</span></label>
                            <div class="col-md-8 textaligncenter">
                                <div class="form-group ">
                                    <p class="content-view" >
                                        {{profileData?.mobileNumber || '--'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline">
                            <label class="col-md-4 textalignright">Address <span>:</span></label>
                            <div class="col-md-8 textaligncenter">
                                <div class="form-group ">
                                    <p class="content-view" >
                                        {{profileData?.email || '--'}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center mt40 mb40">
                        <button class="btn btn-large  max-WT-150 btn-theme" (click)="changePassword()">Change
                            Password</button>
                        <button class="btn btn-large  max-WT-150 btn-theme" (click)="editProfile()">Edit</button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>